module.exports = __webpack_public_path__ + "img/star-filled-grey.82ae0ec4.svg";